import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoginPage from '../pages/LoginPage';
import AppLayout from '../components/Layout/AppLayout';
import CampaignListPage from '../pages/CampaignListPage';
import CampaignCreatePage from '../pages/CampaignCreatePage';
import CampaignPreviewPage from '../pages/CampaignPreviewPage';
import CampaignLogPage from '../pages/CampaignLogPage';
import MsisdnBlacklistPage from '../pages/MsisdnBlacklistPage';
import MsisdnBlacklistCreatePage from '../pages/MsisdnBlacklistCreatePage';
import AuditTrailPage from '../pages/AuditTrailPage';
import SourceChannelListPage from '../pages/SourceChannelListPage';
import SourceChannelFormPage from '../pages/SourceChannelFormPage';

function RequireAuth() {
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
}

function RedirectIfAuthenticated() {
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  if (user) {
    const redirectTo = location.state?.from?.pathname || '/campaigns';
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}

const AppRoutes = () => (
  <Routes>
    <Route element={<RedirectIfAuthenticated />}>
      <Route path="/login" element={<LoginPage />} />
    </Route>
    <Route element={<RequireAuth />}>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Navigate to="/campaigns" replace />} />
        <Route path="/campaigns" element={<CampaignListPage />} />
        <Route path="/campaigns/new" element={<CampaignCreatePage />} />
        <Route path="/campaigns/new/preview" element={<CampaignPreviewPage />} />
        <Route path="/campaign-logs" element={<CampaignLogPage />} />
        <Route path="/msisdn-blacklist" element={<MsisdnBlacklistPage />} />
        <Route path="/msisdn-blacklist/new" element={<MsisdnBlacklistCreatePage />} />
        <Route path="/audit-trail" element={<AuditTrailPage />} />
        <Route path="/source-channels" element={<SourceChannelListPage />} />
        <Route path="/source-channels/new" element={<SourceChannelFormPage mode="create" />} />
        <Route path="/source-channels/:id/edit" element={<SourceChannelFormPage mode="edit" />} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/campaigns" replace />} />
  </Routes>
);

export default AppRoutes;
